<template>
  <div>
    <div>
      <el-form
        ref="form"
        :model="params"
        label-width="100px"
        label-position="left"
      >
        <el-form-item v-if="index == 1" label="人员类型" prop="type">
          <el-select style="width:100%" v-model="params.type" placeholder="请选择">
            <el-option
              v-for="item in typeList"
              :key="item.id"
              :label="item.label"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="index == 1" label="接收人员" prop="name">
          <el-select @change="selectPersonnel" style="width:100%" v-model="params.personnel" placeholder="请选择">
            <el-option
              v-for="item in personnelList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item v-if="index == 1" label="手机号码" prop="name">
         <el-input v-model="params.phone" :disabled="true" placeholder="手机号码"></el-input>
        </el-form-item>
        <el-form-item v-if="index == 1" label="验证码" prop="name">
          <el-input maxLength="6" v-model="params.code" placeholder="请输入验证码"></el-input>
          <!-- <el-link :underline="false">获取下划线</el-link> -->
          <span @click="getCode" v-if="setInter" style="color:rgb(64, 158, 255);position: absolute;width: 90px;left: 300px;">获取验证码</span>
          <span v-else style="color:#ccc;position: absolute;width: 120px;left: 265px;">{{ ms }}秒后重新获取</span>
        </el-form-item>
        <!--  -->
        <el-form-item v-if="index == 2" label="选择人员" prop="name">
          <el-select style="width:100%" collapse-tags multiple v-model="params.perList" placeholder="请选择">
            <el-option
              v-for="item in personnelList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <div>
        <span style="color:rgb(255, 198, 118);margin-left: 76px;">
          {{ index == 1?'提示：转让人员为单选，请谨慎操作.':'提示：人员可多选，数据来源公司账户人员'}}
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import {url} from '@/utils/config'
import {postFun,getFun} from '@/utils/httpFun'
export default {
  props:{
    data:{
      type:Object,
      default:()=>{}
    },
    index:{
      type:Number,
      default:1
    },
    perList:{
      type:Array,
      default:()=>[]
    }
  },
  watch:{
    'params.type'(newState,preState){
      this.getPersonnelList(newState)
    }
  },
  data(){
    return {
      ms:60,
      setInter:true,
      typeList:[
        // {
        //   id:3,
        //   label:'代理商'
        // },
        {
          id:4,
          label:'工程商'
        }
      ],
      personnelList:[],
      params:{
        perList:[],
        personnel:'',
        type:'',
        phone:'',
        code:''
      }
    }
  },
  created(){
    this.$bus.$off('getPersonnelList');
    this.$bus.$on('getPersonnelList',res=>{
      this.getPersonnelList();
    })
  },
  methods:{
    getCode(){
      if(!!!this.params.personnel ){
        this.$message.warning('请完善上方的信息')
        return;
      }
      window.clearInterval(this.interKey);
      this.setInter = false;
      this.interKey = window.setInterval(()=>{
        this.ms --;
        
        if(this.ms <= 0){
          this.setInter = true;
          this.ms = 60;
          window.clearInterval(this.interKey)
        }
      },1000)

      this.sendCode();
    },
    selectPersonnel(item){
      // console.log('选择工程商',item,this.personnelList);
      for(let i of this.personnelList){
        if(item == i.id){
          // console.log('iiiiii',i,this.personnelList[i])
          this.params.phone = i.phone;
          return;
        }
      }
    },
    sendCode(){
      getFun(url.SENDCODE+'?phone='+this.params.phone,{},res=>{
          if(res.data){
              this.countdown()
          }else{
              this.$mmessage.warning('网络繁忙'); 
          }
      })
    },
    add() {
    },
    async submit(){
      if(this.index == 1){
        if(this.params.personnel == '' || this.params.type == ''){
          this.$message.warning("请选择完整");
          return;
        }
        let param = {
          type:4,
          id:this.params.personnel,
          projectId:this.data.id
        }
        console.log('url',param)
        await postFun(url.PROJECT.TRANSFERPROJECT,param,res=>{
          if(res.data){
            this.$message.success("转让成功");
            // this.$emit("setIsIf",true)
            console.log("转让成功")
            this.$emit("setIsIf",true)
          }else{
            this.$message.warning("转让失败")
          }
          this.$bus.$emit('close')
        })
      }else if(this.index == 2){
        if(this.params.perList.length == 0){
          this.$message.warning("请选择邀请人员");
          return;
        }
        await postFun(url.PROJECT.INVITEMEMBER,{
          id:this.params.perList,
          projectId:this.data.id
        },res=>{
          if(res.data){
            this.$message.success("邀请成功");
            this.perList = []
            this.$bus.$emit('personnel-close',false)
          }else{
            this.$message.warning("邀请失败")
          }
          // this.$emit("Close");
        })
      }
    },
    async getPersonnelList(selectionIndex = -1){
      let param = {
        state:3
      };
      if(selectionIndex != -1){
        param = {
          state:selectionIndex
        }
      }
      await postFun(url.PROJECT.GETPERSONNER,param,res=>{
        if(res.data == null || res.data.length == 0){
          this.personnelList = [];
        }else{
          if(param.state == 3){
            console.log('当前登录',this.$store.state.agentUser)
            let user = this.$store.state.agentUser;
            res.data =  res.data.filter(item=>item.phone != user.account)
          }
          this.personnelList = res.data;
        }
      })
    },
    clearPerList(){
      this.params.perList = [];
    }
  }
}
</script>

<style>

</style>